import { setCookie } from '@/lib/config/cookies';
import type { ChartInterval } from './types';

export const CHART_TIMEFRAME_COOKIE = 'morfi-chart-timeframe';

export function parseChartTimeframePreference(value: string | undefined): ChartInterval {
  switch (value) {
    case 'live':
    case '1h':
    case '6h':
    case '1d':
    case '1w':
    case '1mo':
    case 'all':
      return value;
    default:
      return 'live';
  }
}

/** Local storage owns the preference; SSR needs the same history window. */
export function writeChartTimeframeCookie(interval: ChartInterval): void {
  if (typeof document === 'undefined') return;
  setCookie(CHART_TIMEFRAME_COOKIE, interval, 365 * 24 * 60 * 60);
}
